/// <amd-module name="Feed/Legacy/Components/WrappedIvyPromotePanel" />
import * as React from "react";
import { connect } from "react-redux";

import { IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { IFeedHubViewState } from "Feed/Core/Redux/FeedHub/FeedHubContracts";

interface IIvyPromotePanelProps {
    show: boolean;
}

/**
 * Dynamically loads the feed-ivypromote bundle and instantiates the global settings panel component
 */
class IvyPromotePanel extends React.Component<IIvyPromotePanelProps> {
    constructor(props: IIvyPromotePanelProps, context?: IVssComponentContext) {
        super(props, context);
    }

    public render() {
        const show = this.props.show;
        return show ? (
            <WrappedComponent
                dependencies={["ms.feed.feed-ivypromote"]}
                wrappedType="ms.feed.feed-ivypromote.ivy-promote-panel"
            />
        ) : null;
    }
}

function mapStateToProps(state: IFeedHubViewState): IIvyPromotePanelProps {
    return {
        show: !!state.ui.showIvyPromote
    };
}

export const WrappedIvyPromotePanel = connect(mapStateToProps)(IvyPromotePanel);
